module.exports = __webpack_public_path__ + "img/1-3.44ed1514.png";